import React, { useEffect, useState } from "react";

const STORAGE_KEY = "cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (!saved) setVisible(true);
    } catch (e) {
      setVisible(true);
    }
    // Listen for re-open from footer "Cookies" link
    const onReopen = () => setVisible(true);
    window.addEventListener("open-cookie-banner", onReopen);
    return () => window.removeEventListener("open-cookie-banner", onReopen);
  }, []);

  const updateConsent = (granted) => {
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", {
        analytics_storage: granted ? "granted" : "denied",
        ad_storage: granted ? "granted" : "denied",
        ad_user_data: granted ? "granted" : "denied",
        ad_personalization: granted ? "granted" : "denied",
      });
    }
  };

  const handleAccept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "accepted");
    } catch (e) {}
    updateConsent(true);
    setVisible(false);
  };

  const handleRefuse = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "refused");
    } catch (e) {}
    updateConsent(false);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 99999,
        background: "#ffffff",
        borderTop: "3px solid #F97316",
        boxShadow: "0 -4px 20px rgba(0,0,0,0.12)",
        padding: "16px 20px",
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "center",
        gap: "16px",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      }}
    >
      <div
        style={{
          flex: "1 1 480px",
          minWidth: "260px",
          color: "#1f2937",
          fontSize: "14px",
          lineHeight: "1.5",
        }}
      >
        <strong style={{ color: "#F97316", display: "block", marginBottom: "4px" }}>
          🍪 Respect de votre vie privée
        </strong>
        Nous utilisons des cookies pour mesurer l'audience du site (Google Analytics).
        Vous pouvez accepter ou refuser ce suivi. Votre choix est conservé 12 mois et
        modifiable à tout moment via le lien « Cookies » en bas de page.{" "}
        <a
          href="/politique-confidentialite"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#F97316", textDecoration: "underline" }}
        >
          En savoir plus
        </a>
      </div>
      <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
        <button
          data-testid="cookie-refuse-btn"
          onClick={handleRefuse}
          style={{
            padding: "10px 22px",
            borderRadius: "8px",
            border: "1.5px solid #d1d5db",
            background: "#ffffff",
            color: "#374151",
            cursor: "pointer",
            fontWeight: 600,
            fontSize: "14px",
            transition: "all 0.2s",
          }}
          onMouseOver={(e) => (e.currentTarget.style.background = "#f3f4f6")}
          onMouseOut={(e) => (e.currentTarget.style.background = "#ffffff")}
        >
          Refuser
        </button>
        <button
          data-testid="cookie-accept-btn"
          onClick={handleAccept}
          style={{
            padding: "10px 22px",
            borderRadius: "8px",
            border: "none",
            background: "#F97316",
            color: "#ffffff",
            cursor: "pointer",
            fontWeight: 600,
            fontSize: "14px",
            boxShadow: "0 2px 6px rgba(249,115,22,0.35)",
            transition: "all 0.2s",
          }}
          onMouseOver={(e) => (e.currentTarget.style.background = "#ea580c")}
          onMouseOut={(e) => (e.currentTarget.style.background = "#F97316")}
        >
          Accepter
        </button>
      </div>
    </div>
  );
}
